import { NewPassword } from '../../components/landing/NewPassword';

export function NewPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-900 dark:to-black">
      <NewPassword />
    </div>
  );
}
